<template>
  <div class="container">
    <div class="row">
      <img src="../assets/WhtBrd-bars.png" class="logo mt-2 mb-3">
      <form class="form col-10 offset-1">
          
          <div v-show="showEmailTxt">
            <h4 class="text-center">Email</h4>
            <input type="text" v-model="email" class="form-control mt-2" :class="[validClass.email]" placeholder="Email"/>
            <label class="custom-control custom-checkbox mt-2">
              <input type="checkbox" class="custom-control-input" v-model="saveEmail">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">Save Email?</span>
            </label>
          </div>
          <div v-show="!showEmailTxt" class="text-center mb-4">
            Email: {{email}} <span class="text-primary"><a @click="changeUser">not you?</a></span>
          </div>
          <h3 class="text-center">Enter PIN</h3>
          <div class="pin-group"> 
            <input type="number" min="0" inputmode="numeric" pattern="[0-9]*" v-model="pin1" ref="pin1" @keyup="pinInput(1)" @keyup.delete="pinDelete(1)" class="form-control pinbox" :class="[validClass.pin]" maxlength="1" />
            <input type="number" min="0" inputmode="numeric" pattern="[0-9]*" v-model="pin2" ref="pin2" @keyup="pinInput(2)" @keyup.delete="pinDelete(2)" class="form-control pinbox ml-1 mr-1" :class="[validClass.pin]" maxlength="1" />
            <input type="number" min="0" inputmode="numeric" pattern="[0-9]*" v-model="pin3" ref="pin3" @keyup="pinInput(3)" @keyup.delete="pinDelete(3)" class="form-control pinbox mr-1" :class="[validClass.pin]" maxlength="1" />
            <input type="number" min="0" inputmode="numeric" pattern="[0-9]*" v-model="pin4" ref="pin4" @keyup="pinInput(4)" @keyup.delete="pinDelete(4)" class="form-control pinbox" :class="[validClass.pin]" maxlength="1" />
          </div>
          
          <button class="btn btn-outline-primary mt-4 btn-lg col-8 offset-2" @click.prevent="login">Login</button>
          <p v-if="showEmailTxt" class="text-center mt-2">No Account? <router-link to="/signup">Sign Up!</router-link></p>
      </form>
    </div>
  </div>
</template>

<script>
import firebase from  'firebase'

export default {
  name: 'login',
  data () {
    return {
      email: "",
      showEmailTxt: false,
      pin1: "",
      pin2: "",
      pin3: "",
      pin4: "",
      saveEmail: false,
      validClass: {
        pin : 'valid',
        email: 'valid'
      }
    }
  },
  computed: {
    password: function () {
      return `${this.pin1}${this.pin2}${this.pin3}${this.pin4}-WhtBrd`
    }
  },
  created () {
    let authEmail = this.$localStorage.get('authEmail', 'notSet')
    if(authEmail != 'notSet') {
      console.log('AuthEmail is set...Filling in Email')
      this.email = authEmail
      this.saveEmail = true
    } else {
      console.log('AuthEmail is not set')
      this.showEmailTxt = true
    }
  },
  methods: {
      changeUser: function (){
        this.email = ""
        this.showEmailTxt = true
      },
      pinInput: function (pin) {
        //console.log(this.$refs[`pin${pin}`].value)
        if(this.$refs[`pin${pin}`].value.length === 1 && pin != 4) {
          this.$refs[`pin${pin+1}`].focus()
        }
      },
      pinDelete: function (pin) {
        if (this.$refs[`pin${pin}`].value.length === 1) {
          this.$refs[`pin${pin}`].value = ""
        } else if (this.$refs[`pin${pin}`].value.length < 1 && pin != 1) {
          this.$refs[`pin${pin-1}`].value = ""
          this.$refs[`pin${pin-1}`].focus()
        }
      },
      isValid: function () {
        //reset all values
        this.formErrors = []
        this.validClass.email = 'valid'
        this.validClass.pin = 'valid'

        if (this.email == ""){
          this.validClass.email = "is-invalid"
          this.formErrors.push("Sorry, 'email' must ba a valid email address.")
        } 
        if (this.pin1 == "" || this.pin2 == "" || this.pin3 == "" || this.pin4 == ""){
          this.pin4 = ""
          this.pin3 = ""
          this.pin2 = ""
          this.pin1 = ""
          this.validClass.pin = "is-invalid"
          this.formErrors.push("Woops, You must enter a 4 digit numeric PIN, Try again!")
        }

        if (this.formErrors.length == 0) {
          return true
        } else {
          return false
        }

      },
      login: function () {
        let isValid = this.isValid()
        if(isValid){

          if(this.saveEmail) {
            this.$localStorage.set('authEmail', this.email)
          } else {
            this.$localStorage.remove('authEmail')
            console.log('if set AuthEmail is set ... being removed')
          }

          firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then(user => {
              console.log('User Logged in successfully.')
              this.$store.commit('setAuthUser')

              this.$store.commit('setWorkouts')
              this.$store.commit('setAllWorkouts')
              
              this.$store.state.db.collection('users').doc(user.uid).get()
              .then(doc => {
                //console.log(doc.data())
                this.$store.commit('setUser', doc.data())

                this.$router.replace("home")
              })
              .catch(err => {
                console.log(`Woops Error get user data. Err: ${err}`)
                this.$notify({
                  group: 'note', 
                  title: "Woops", 
                  text: err.message, 
                  type: 'error', 
                  duration: 4500,
                })
              })
          }, err => {
              console.log(`Woops. Err: ${err.message}`)
              this.validClass.pin = "is-invalid"
              this.pin4 = ""
              this.pin3 = ""
              this.pin2 = ""
              this.pin1 = ""
              this.$refs['pin1'].focus()
              this.$notify({
                  group: 'note', 
                  text: "Sorry username or password is incorrect or not found", 
                  type: 'error', 
                  duration: 5000,
                })
          })

        } else {
          let errorTxt = ""
          this.formErrors.forEach((err,index) => {
            errorTxt += `${index+1}. ${err}<br/>`
          })

          this.$notify({
            group: 'note',
            text: errorTxt,
            type: 'error'
          })
        }
          
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.logo {
  width:60%;
  height: 60%;
  display:block;
  margin:auto;
}

.pin-group {
    display: flex;
    justify-content: center;
    align-items: center
}
.pinbox {
    padding: 10px; 
    width: 70px;
    height: 70px;
    text-align: center;
    font-size: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue